import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { Constantes } from '../../shared/constant/constantes';
import { UtilidadMenuEstadisticas } from '../../shared/utilities/utilidad-menu-estadisticas';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { OpinionComponent } from './opinion/opinion.component';
import { MatDialog } from '@angular/material/dialog';
import { HeaderComponent } from '../../shared/header/header.component';
import { MenuMasConsultadosComponent } from '../public/menu-mas-consultados/menu-mas-consultados.component';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { environment } from '../../../../environments/environment.development';

declare const $: any;

@Component({
  selector: 'app-estadisticas-inicial',
  templateUrl: './estadisticas-inicial.component.html', //'',
  styleUrls: ['./estadisticas-inicial.component.css'],
  standalone: true,
  imports: [HeaderComponent, MenuMasConsultadosComponent, CdkDrag]
})
export class EstadisticasInicialComponent implements OnInit {
  public constante: Constantes = new Constantes();
  public utilidadMenuEstadisticas = UtilidadMenuEstadisticas.getInstance();
  public urlImagen = "/estadisticas-economicas/assets/img/menu-inicial/";
  public extImg = ".jpg";
  public imgNuestrosDatos: string = '';
  public imgCalendario: string = '';
  public imgEncuestaEspectativa: string = '';
  public imgAudiorespuesta: string = '';
  public imgWebserice: string = '';
  public imgHistorico: string = '';

  public urlHistorico: string = '';
  public urlIndicadores: string = environment.APP_INDICADORES_ECONOMICOS_DIA;
  public urlBuscador: string = environment.APP_DESCARGA_MULTIPLE_DATOS;
  public urlGraficador: string = environment.APP_GRAFICADOR;

  public dragPosition = { x: 0, y: 0 };

  constructor(private router: Router, private service: VisualizadorService, public dialog: MatDialog, private location: Location) {
  }

  ngAfterViewInit(): void {
    this.service.setWindowScroll(0, 0);
  }

  ngOnInit(): void {
    const currentUrl = this.location.path();
    this.service.generaTagsHtmlSEO('Datos estadisticas económicas Banco de la República - Banco central de Colombia', 'Página inicial de estadisticas económicas', 'estadisticas, económicas', currentUrl);

    this.selectOpcion("catalogo", "catalogo");
    this.selectOpcion("calendario", "calendario");
    this.selectOpcion("estadisticaEncuesta", "encuestaEspectativa");
    this.selectOpcion("audiorespuesta", "audiorespuesta");
    this.selectOpcion("webservice", "webservices");
    this.selectOpcion("estadisticas-banrep", "historico");
    this.consultarURLHistorico();
  }

  public abrirPagina(datoRef: string) {
    var tipoYEnlace = this.obtenerEnlace(datoRef);
    var arrayTipoYEnlace = tipoYEnlace.split("|");
    var tipo: string = arrayTipoYEnlace[0];
    var enlace: string = arrayTipoYEnlace[1];
    if (this.constante.TIPO_URL_INTERNA === tipo) {
      this.router.navigate([enlace]);
    } else {
      this.service.windowOpen(enlace, '_blank');
    }
  }

  public selectOpcion(nameImg: string, opcion: string) {
    let construyeImagen = this.urlImagen + nameImg + this.extImg;
    switch (opcion) {
      case 'catalogo':
        this.imgNuestrosDatos = construyeImagen;
        break;
      case 'calendario':
        this.imgCalendario = construyeImagen;
        break;
      case 'encuestaEspectativa':
        this.imgEncuestaEspectativa = construyeImagen;
        break;
      case 'audiorespuesta':
        this.imgAudiorespuesta = construyeImagen;
        break;
      case 'webservices':
        this.imgWebserice = construyeImagen;
        break;
      default:
        this.imgHistorico = construyeImagen;
    }
  }

  private obtenerEnlace(select_link: string): string {
    var ulrEnlace: string;
    switch (select_link) {
      case 'catalogo':
        ulrEnlace = 'INTERNO|' + this.constante.urlCatalogo;
        break;
      case 'boletines':
        ulrEnlace = 'INTERNO|' + this.constante.urlBoletines;
        break;
      case 'calendario':
        ulrEnlace = 'INTERNO|' + this.constante.urlCalendario;
        break;
      case 'estadisticaEncuesta':
        ulrEnlace = 'INTERNO|' + this.constante.urlEncuesta;
        break;
      case 'instrucciones':
        ulrEnlace = 'INTERNO|' + this.constante.urlInstrucciones;
        break;
      case 'webService':
        ulrEnlace = 'INTERNO|' + this.constante.urlWebservice;
        break;
      case 'certificacionCalidad':
        ulrEnlace = 'INTERNO|' + this.constante.urlCertificacionCalidad;
        break;
      case 'graficador':
        ulrEnlace = 'EXTERNO|' + this.urlGraficador;
        break;
      case 'shopping':
        ulrEnlace = 'EXTERNO|' + this.urlBuscador;
        break;
      case 'audiorespuesta':
        ulrEnlace = 'EXTERNO|' + this.urlIndicadores;
        break;
      case 'dashboard':
        ulrEnlace = 'INTERNO|' + this.constante.urlDashboard;
        break;
      case 'historico':
        ulrEnlace = 'EXTERNO|' + this.urlHistorico;
        break;
      default:
        ulrEnlace = 'EXTERNO|#';
    }
    return ulrEnlace;
  }

  private consultarURLHistorico() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_SERIE_HITORICO).subscribe({
      next: (data) => {
        this.urlHistorico = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  public openDialogOpinion() {
    this.dialog.open(OpinionComponent, {
      data: {

      },
      height: '600px',
      width: '1000px'
    });
  }
}
